import { combineReducers } from "redux";
import entities from "./entities";
import currentUser from "./currentUser";
import server from "./server";

export const reducers = {
  entities,
  currentUser,
  server
};

export default combineReducers(reducers);
